import { render, staticRenderFns } from "./datetime.vue?vue&type=template&id=a23bd5dc&scoped=true"
import script from "./datetime.vue?vue&type=script&lang=js"
export * from "./datetime.vue?vue&type=script&lang=js"
import style0 from "./datetime.vue?vue&type=style&index=0&id=a23bd5dc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a23bd5dc",
  null
  
)

export default component.exports